// Port of api/fuel/app/classes/filter/data/lists.php
import Game from 'offline/model/game'

export default {
	run: function(config, filter, packageItems, data) {
		var gameIds = []
		var rows
		var i

		data.games = data.games || []

		for (i = 0; i < packageItems.length; i++) {
			if (packageItems[i].games && packageItems[i].games.length) {
				gameIds = gameIds.concat(packageItems[i].games)
			}
		}

		gameIds = gameIds.filter(function(id, index) {
			return id && gameIds.indexOf(id) === index
		})

		if (gameIds.length) {
			rows = Game.where([
				['game_id', 'in', gameIds]
			])
			for (i = 0; i < rows.length; i++) {
				data.games.push(rows[i].to_array())
			}
		}

		return data
	}
}
